import "./Avatar.css";

interface AvatarProps {
  imageUrl?: string;
  name: string;
  size?: number;
}

const getAvatarInitials = (name: string) => {
  const names = name.split(" ");
  if (names.length > 1) {
    return names[0][0] + names[1][0];
  }
  return name[0];
};

const Avatar = ({ name, size = 40 }: AvatarProps) => {
  return (
    <div
      className="avatar-component"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${Math.floor(size / 3)}px`,
      }}>
      {getAvatarInitials(name)}
    </div>
  );
};

export { Avatar };
